import Wrapper from '../Wrapper';
import { useMutation, UseMutationOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { subscriptionQueryOptions, upcomingInvoiceQueryOptions } from '../../utils/queryOptions';
import dayjs from 'dayjs';


const UpcomingInvoiceOverview = () => {

  const upcomingInvoice = useSuspenseQuery(upcomingInvoiceQueryOptions());
  const { data: subscription } = useSuspenseQuery(subscriptionQueryOptions());

  let Euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

  function formatToCurrency(number: number | null) {
    if (number !== null) {
      return Euro.format(number / 100);
    }
  }

  //rinnovo automatico non attivo
  if (subscription.cancel_at_period_end || !upcomingInvoice?.data?.lines?.data) {
    return (
      <Wrapper title={'Prossima fattura'} subtitle={'Rinnovo automatico disattivato.'}>
      </Wrapper>
    );
  }

  return (
    <Wrapper title={'Anteprima prossima fattura'}
             subtitle={`Sarà addebitata il ${upcomingInvoice.data.next_payment_attempt && dayjs(upcomingInvoice.data.next_payment_attempt * 1000).format('DD/MM/YY')}`}>
      {upcomingInvoice.data.lines.data.map((line) => (
        <div key={line.id} className={'flex justify-between gap-2'}>
          <p>{line.description}</p><p>{formatToCurrency(line.amount_excluding_tax)}</p>
        </div>
      ))}
      {upcomingInvoice.data.discounts && upcomingInvoice.data.discounts.map((discount) => {
        if (typeof discount === 'string') {
          return <></>;
        }
        return (
          <div key={discount.coupon.id} className={'flex justify-between gap-2'}>
            <p>{discount.coupon.name}</p><p>-{formatToCurrency(discount.coupon.amount_off)}</p>
          </div>
        );
      })}
      <div className={'flex justify-between gap-2'}>
        <p>Tasse (IVA 22%)</p><p>{formatToCurrency(upcomingInvoice.data.tax)}</p>
      </div>
      <div className={'flex justify-between mt-2 border-t pt-2 gap-2'}>
        <p className={'font-bold'}>Totale</p><p>{formatToCurrency(upcomingInvoice.data.total)}</p>
      </div>
    </Wrapper>
  );
};
export default UpcomingInvoiceOverview;
